import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getPetClaim } from '@/services/claims.services'
import {
  CLAIMS_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type { PetClaim } from '@/shared/types/global.types'

export function usePetClaim(claimId: string, policyIds: string[]) {
  const { i18n } = useTranslation()

  return useQuery<PetClaim>({
    queryKey: CLAIMS_QUERY_KEYS.petDetail(claimId),
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getPetClaim(token, i18n.language, claimId, policyIds)
    },
    enabled: !!claimId && policyIds.length > 0,
    // A 404 means the claim isn't in the user's lists; no point retrying
    retry: false,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
